module.exports = __webpack_public_path__ + "static/media/mint-background-2.0c58fb38.png";